import axios from 'axios'

export type PortalOrderStatus = {
  orderId: string
  status: string | null
  statusComment: string | null
  salesOrderNumber: string | null
  portalUrl: string | null
  rejectionCode: string | null
  rejectionComments: string | null
  hasCorrection: boolean
}

export async function fetchOrderStatus(quoteId: string) {
  const { data } = await axios.get<PortalOrderStatus>(`/quote/${quoteId}/orderStatus`)
  return data
}
